module.exports = __webpack_public_path__ + "sw-pc-jerry-resize.jpg?a9dafe1dafd5ad240e9aaebeb92be6bc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sw-pc-jerry-resize.jpg
// module id = 333
// module chunks = 0